export const donationContractAddress = '0x816ADBae6279DeF3658E093206b6A9C8ee90B36c';